import { render } from "./Tag.vue?vue&type=template&id=fe2528d8"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=fe2528d8&lang=css"
script.render = render

export default script